/* eslint-disable import/prefer-default-export */

import { atom } from 'recoil';
import { GOOGLE_SSO_LOADING } from './constants';

export const googleSSOLoadingAtom = atom({
  key: GOOGLE_SSO_LOADING,
  default: false,
});
